var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataCenterFieldSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Data_Center_Field_Support",
    "data-name": "Data Center Field Support",
    transform: "translate(0.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 88,
    cy: 88,
    r: 88,
    transform: "translate(-0.056)",
    fill: "rgba(214,233,255,0.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 75.3,
    cy: 75.3,
    r: 75.3,
    transform: "translate(12.7 12.7)",
    fill: "#d1e6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10627",
    "data-name": "Group 10627",
    transform: "translate(27 27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10626",
    "data-name": "Group 10626"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(-0.056)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "dns_black_24dp",
    transform: "translate(53.943 54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3629",
    "data-name": "Path 3629",
    d: "M0,0H68.009V68.009H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3630",
    "data-name": "Path 3630",
    d: "M5,16.335H44.672V5H5Zm5.667-9.918a4.251,4.251,0,1,1-4.251,4.251A4.245,4.245,0,0,1,10.667,6.417ZM5,44.672H44.672V33.337H5Zm5.667-9.918A4.251,4.251,0,1,1,6.417,39,4.245,4.245,0,0,1,10.667,34.754Z",
    transform: "translate(9.168 9.168)",
    fill: "#d6e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3631",
    "data-name": "Path 3631",
    d: "M51.173,31.337H5.834A2.842,2.842,0,0,0,3,34.171v17a2.842,2.842,0,0,0,2.834,2.834H51.173a2.842,2.842,0,0,0,2.834-2.834v-17A2.842,2.842,0,0,0,51.173,31.337Zm-2.834,17H8.667V37H48.339Zm-34-1.417a4.251,4.251,0,1,0-4.251-4.251A4.245,4.245,0,0,0,14.335,46.922ZM51.173,3H5.834A2.842,2.842,0,0,0,3,5.834v17A2.842,2.842,0,0,0,5.834,25.67H51.173a2.842,2.842,0,0,0,2.834-2.834v-17A2.842,2.842,0,0,0,51.173,3ZM48.339,20H8.667V8.667H48.339Zm-34-1.417a4.251,4.251,0,1,0-4.251-4.251A4.245,4.245,0,0,0,14.335,18.585Z",
    transform: "translate(5.501 5.501)",
    fill: "#12355f"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataCenterFieldSupport);
export default __webpack_public_path__ + "static/media/Data Center Field Support.99d7c62630bb4ae594190264b62379ca.svg";
export { ForwardRef as ReactComponent };